module.exports = __webpack_public_path__ + "assets/images/obitwriter.dc7e1a83.png";


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/ResourcesBlock/assets/obitwriter.png
// module id = 1679
// module chunks = 0